export default class Expander {
    dom;
    expandCallBack;
    clickCallBack;
    closeCallBack;

    constructor(dom, callback) {
        this.dom = dom;
        let keys = Object.keys(callback);
        for (let item of keys) {
            if (item == "expand") {
                this.expandCallBack = callback[item];
            } else if (item == "select") {
                this.clickCallBack = callback[item];
            } else if (item == "close") {
                this.closeCallBack = callback[item];
            }
        }
    }
    expand() {
        this.expandCallBack && this.expandCallBack();
        window.addEventListener("mousedown", this.close);
    }
    select(args) {
        this.clickCallBack && this.clickCallBack(args);
        window.removeEventListener("mousedown", this.close);
    }
    close = (e) => {
        let objTarget = this.dom;
        if (objTarget != e.target && !objTarget?.contains(e.target)) {
            this.closeCallBack && this.closeCallBack();
            window.removeEventListener("mousedown", this.close);
        }
    };
    fClose = () => {
        window.removeEventListener("mousedown", this.close);
        this.closeCallBack && this.closeCallBack();
    };
}
